<template>
   <table-component-buefy
    v-if="mixin.loaded"
    :hide_table_search="true"
    :content="smsLogs"
    :headings="headings"
    :item_keys="item_keys"
    :display_spec="certificateSpecs"
    :total_items="mixin.total_items"
    :pagination_callback="mixin.loadItems"
    :col_styles="col_styles">
  </table-component-buefy>
  <!-- Loader -->
  <loader-component v-else></loader-component>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import { smsLogSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'certificate-list-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Sent', 'To', 'From', 'Message', 'Status'],
        item_keys: ['created', 'receiver', 'sender', 'message', 'statusResult'],
        col_styles: { 'ststusResult': ['alignLeft'] },
        certificateSpecs: smsLogSpecs,
        mixin: {
          actionMethod: this.getSmsLogs,
          actionParams: { customer: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    components: {
      TableComponentBuefy,
      LoaderComponent
    },
    computed: {
      ...mapState({
        smsLogs: state => state.customerModule.smsLogs
      })
    },
    methods: {
      ...mapActions([
        'getSmsLogs'
      ])
    }
  }
</script>
